import React from 'react';
import Kiosk from '../../../assets/images/ico_kiosk_nestedMenu.svg';

export const KioskIcon = () => {
  return <img src={Kiosk} style={{ width: '24px' }} />;
};
